const customStyle = () =>{
    return {
        typography: {
          fontFamily: [
            'Ubuntu',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
          ].join(','),
        //   body2: {
        //     fontSize: "12px",
        //     fontWeight: '600',
        //     fontFamily: 'Ubuntu',
        //     //padding: '10px'
        //   },
        //   body1: {
        //     fontSize: "12px",
        //     fontWeight: '600',
        //     fontFamily: 'Ubuntu'
        //   },
        //   subtitle1: {
        //     fontSize: "11px",
        //     fontWeight: 'bold',
        //     fontFamily: 'Ubuntu'
        //   },
        //   subtitle2: {
        //     fontSize: "11px",
        //     fontFamily: 'Ubuntu'
        //   },
        //   h1: {
        //     fontSize: "3rem",
        //     fontWeight: 'bold',
        //     fontFamily: 'Ubuntu',
        //     padding: '10px',
        //     color: "#0080c8"
        //   },
        //   h2: {
        //     fontSize: "12px",
        //     fontWeight: 'bold',
        //     fontFamily: 'Ubuntu',
        //     padding: '10px',
        //     color: "#828282"
        //   },
        //   h3: {
        //     fontSize: "12px",
        //     fontWeight: '600',
        //     fontFamily: 'Ubuntu',
        //     borderBottom: 'solid 1px #f0f4f9',
        //     padding: '10px'
        //   },
        //   h4: {
        //     fontSize: "12px",
        //     fontWeight: '600',
        //     fontFamily: 'Ubuntu',
        //   },
        //   h5: {
        //     fontSize: "14px",
        //     fontWeight: '600',
        //     fontFamily: 'Ubuntu'
        //   },
        //   h6: {
        //     fontSize: "16px",
        //     fontWeight: '600',
        //     fontFamily: 'Ubuntu'
        //   }
        }
      }
}

export default customStyle;